import { Permission, PermissionLevel } from '@/constants/client/permission';
import type { IUserPermission } from '@/api/types';
import { store } from '@/store';

export const hasPermission = (permission: Permission, permissionLevel: PermissionLevel): boolean => {
  const currentUserPermissions: IUserPermission[] = store.getState().auth.user?.userPermissions ?? [];

  const userPermission: IUserPermission | undefined = currentUserPermissions.find(
    item => item.permissionId === permission,
  );

  if (userPermission === undefined) return false;

  return validatePermissionLevel(permissionLevel, userPermission.permissionLevelId);
};

const validatePermissionLevel = (permissionLevel: PermissionLevel, givenLevel: PermissionLevel): boolean => {
  if (
    permissionLevel === PermissionLevel.VIEW &&
    (givenLevel === PermissionLevel.VIEW || givenLevel === PermissionLevel.MODIFY)
  )
    return true;

  if (permissionLevel === PermissionLevel.MODIFY && givenLevel === PermissionLevel.MODIFY) return true;

  if (
    permissionLevel === PermissionLevel.ANY &&
    (givenLevel === PermissionLevel.VIEW || givenLevel === PermissionLevel.MODIFY || givenLevel === PermissionLevel.ANY)
  )
    return true;

  return false;
};

export const canAccessCampaignsNav = (): boolean => {
  if (
    hasPermission(Permission.APPLICATIONS, PermissionLevel.ANY) ||
    hasPermission(Permission.MY_INTERVIEWS, PermissionLevel.ANY) ||
    hasPermission(Permission.ALL_INTERVIEWS, PermissionLevel.ANY) ||
    hasPermission(Permission.MAS, PermissionLevel.ANY) ||
    hasPermission(Permission.MAS_ADMIN, PermissionLevel.ANY)
  )
    return true;
  return false;
};

export const canAccessApplicantsTab = (): boolean => {
  if (
    hasPermission(Permission.APPLICATIONS, PermissionLevel.ANY) ||
    hasPermission(Permission.MAS, PermissionLevel.ANY) ||
    hasPermission(Permission.MAS_ADMIN, PermissionLevel.ANY)
  )
    return true;

  return false;
};

export const canAccessClassesTab = (): boolean => {
  if (
    hasPermission(Permission.APPLICATIONS, PermissionLevel.ANY) ||
    hasPermission(Permission.MAS, PermissionLevel.ANY) ||
    hasPermission(Permission.MAS_ADMIN, PermissionLevel.ANY)
  )
    return true;

  return false;
};

export const canAccessScheduleInterviewTab = (): boolean => {
  if (hasPermission(Permission.MY_INTERVIEWS, PermissionLevel.ANY)) return true;

  return false;
};

export const canMyEarningsTab = (): boolean => {
  if (hasPermission(Permission.MAS, PermissionLevel.VIEW)) return true;

  return false;
};

export const canAccessResourcesNav = (): boolean => {
  if (
    hasPermission(Permission.RESOURCES, PermissionLevel.ANY) ||
    hasPermission(Permission.DATABASES, PermissionLevel.ANY) ||
    hasPermission(Permission.ANNOUNCEMENTS, PermissionLevel.ANY)
  )
    return true;

  return false;
};
